import React, { FC, useCallback, useMemo, useState } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { Button, message } from 'antd';
import { connect } from 'react-redux';
import { remindBiddersToMakeProposal } from '../../thunks/bidders_thunks';
import { withRouter } from 'react-router';

const BidderSendReminderButton: FC<any> = ({
	bidder,
	requestForProposal,
	remindBidders,
}): React.ReactElement => {
	const bidderStatus = useMemo(() => nullSafeGet('bidderStatus', bidder), [bidder]);
	const [loading, setLoading] = useState(false);

	const onSendReminder = useCallback(() => {
		setLoading(true);
		remindBidders(bidder.requestForProposalId, bidder.supplierFacilityId)
			.catch(message.error)
			.finally(() => setLoading(false));
	}, [bidder.requestForProposalId, bidder.supplierFacilityId, remindBidders]);

	return (bidderStatus === 'noResponse' || bidderStatus === 'interested') &&
		nullSafeGetOrElse('status', requestForProposal, 'draft') === 'active' ? (
		<Button loading={loading} onClick={onSendReminder}>
			Send Reminder
		</Button>
	) : null;
};

const mapDispatchToProps = (dispatch, ownProps) => ({
	remindBidders: (id, supplierFacilityId) =>
		dispatch(remindBiddersToMakeProposal(ownProps.userType)(id, supplierFacilityId)),
});

const ComponentWithoutUserType = withRouter(
	connect(null, mapDispatchToProps)(BidderSendReminderButton)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
